<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center border-bottom mb-2 pb-2">
  <h4>
    {{title}}
    <small class="text-muted">{{subTitle}}</small>
    <small class="text-muted" [innerHTML]="innerHtml"></small>
  </h4>
  <div class="btn-toolbar mb-2 mb-md-0">
    <ng-template  appTitleToolbarDirective></ng-template>
  </div>
</div>
